// Celulares do agente logado com o app (pasta ionic/) — /minhas-notificacoes/celular (ver MobileDeviceEndpoints.cs).
import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

const BASE = `${WOOTDASH_BASE}/minhas-notificacoes/celular`

export interface MobileDeviceRegistration {
  token: string
  platform: 'android' | 'ios'
  device: string | null
  appVersion: string | null
}

/** problem nulo = cadastrado. replyToken: token da resposta rápida pela notificação (fase 5) — vai pro app nativo guardar,
 * nunca pro localStorage. */
export interface MobileDeviceRegistrationResult {
  problem: string | null
  replyToken: string | null
}

export async function registerMobileDevice(authToken: string, registration: MobileDeviceRegistration): Promise<MobileDeviceRegistrationResult> {
  try {
    const res = await fetch(`${BASE}/aparelhos`, {
      method: 'POST',
      headers: { ...wootdashAuthHeaders(authToken), 'Content-Type': 'application/json' },
      body: JSON.stringify(registration),
    })
    const data = await res.json().catch(() => null)
    if (res.ok) return { problem: null, replyToken: data?.replyToken ?? null }
    return { problem: data?.problem ?? `Erro ${res.status} ao cadastrar o celular.`, replyToken: null }
  } catch {
    return { problem: 'Não foi possível falar com o servidor.', replyToken: null }
  }
}

/** Logout no app: este celular para de receber os avisos do agente. */
export async function unregisterMobileDevice(authToken: string, deviceToken: string): Promise<void> {
  try {
    await fetch(`${BASE}/aparelhos?token=${encodeURIComponent(deviceToken)}`, { method: 'DELETE', headers: wootdashAuthHeaders(authToken) })
  } catch {
    // Sem rede no logout: o cadastro fica, e o próximo login neste celular (de qualquer agente) passa ele pra frente.
  }
}

// ── Admin › Configurações Gerais › App de celular (settings.manage) ───────────────────────────────────

export interface AdminMobileDevice {
  id: string
  agentId: string
  agentName: string
  agentEmail: string | null
  platform: 'android' | 'ios'
  device: string | null
  appVersion: string | null
  createdAt: string
  updatedAt: string
  lastSuccessAt: string | null
}

const ADMIN = `${WOOTDASH_BASE}/configuracoes/app-celular/aparelhos`

export async function listAllMobileDevices(token: string): Promise<{ data: AdminMobileDevice[] | null; problem: string | null }> {
  try {
    const res = await fetch(ADMIN, { headers: wootdashAuthHeaders(token) })
    if (res.status === 401 || res.status === 403) return { data: null, problem: 'Sem permissão (precisa de settings.manage).' }
    return res.ok ? { data: await res.json(), problem: null } : { data: null, problem: `Erro ${res.status} no servidor.` }
  } catch {
    return { data: null, problem: 'Não foi possível falar com o servidor.' }
  }
}

export async function removeMobileDevice(token: string, id: string): Promise<boolean> {
  try {
    const res = await fetch(`${ADMIN}/${id}`, { method: 'DELETE', headers: wootdashAuthHeaders(token) })
    return res.ok || res.status === 404
  } catch {
    return false
  }
}

/** Envia na hora pelo Firebase e diz se entregou ou o porquê. */
export async function testMobileDevice(token: string, id: string, call = false): Promise<{ delivered: boolean; problem: string | null }> {
  try {
    const res = await fetch(`${ADMIN}/${id}/teste${call ? '?chamada=true' : ''}`, { method: 'POST', headers: wootdashAuthHeaders(token) })
    const data = await res.json().catch(() => null)
    return data && typeof data.delivered === 'boolean' ? data : { delivered: false, problem: `Erro ${res.status} no servidor.` }
  } catch {
    return { delivered: false, problem: 'Não foi possível falar com o servidor.' }
  }
}
